import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import styled from 'styled-components/macro';
import PgHome from '@pages/PgHome';
import PgInfo from '@pages/PgInfo';
import PgSubmissions from '@pages/PgSubmissions';
import PgOrders from '@pages/PgOrders';
import PgOrderCreate from '@pages/PgOrderCreate';
import PgDevTest from '@pages/PgDevTest';
import PgSettings from '@pages/PgSettings';
import PgUserAccount from '@pages/PgUserAccount';

const RoutesProtected = () => {
  return (
    <Content>
      <Routes>
        <Route path='/' element={<Navigate replace to='/home' />} />
        <Route path='/home' element={<PgHome />} />
        <Route path='/info' element={<PgInfo />} />
        <Route path='/user' element={<PgUserAccount />} />
        <Route path='/settings' element={<PgSettings />} />
        <Route path='/submissions' element={<PgSubmissions />} />
        <Route path='/submissions/:action' element={<PgSubmissions />} />
        <Route path='/orders' element={<PgOrders />} />
        <Route path='/orders/create' element={<PgOrderCreate />} />
        <Route path='/orders/:action' element={<PgOrders />} />
        <Route path='/devtest' element={<PgDevTest />} />
        <Route path='/*' element={<Navigate replace to='/' />} />
        <Route path='*' element={<Navigate replace to='/' />} />{' '}
        {/* handle 404 issue on Amazon S3-Hosted */}
      </Routes>
    </Content>
  );
};

export default RoutesProtected;

const Content = styled.div`
  position: absolute;
  margin: 0;
  top: 0;
  left: 50px;
  width: calc(100vw - 50px);
  height: 100vh;
  background: ${(p) => p.theme.palette.backgroundPrimary};
`;
